<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M16.74,14.5h8.35a.91.91,0,0,1,.9,1.06,1,1,0,0,1-.24.46L11.19,30.93a.21.21,0,0,1-.13.07.4.4,0,0,1-.15,0,.22.22,0,0,1-.09-.12.23.23,0,0,1,0-.14L15.26,17.5H6.91A.91.91,0,0,1,6,16.44,1,1,0,0,1,6.25,16L20.81,1.07A.21.21,0,0,1,20.94,1l.15,0a.22.22,0,0,1,.09.12.23.23,0,0,1,0,.14L16.74,14.5Z" />
</svg>